import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  waitingRoomContainer: {
    backgroundColor: '#FFFFFF',
    margin: '0 auto',
    padding: '1rem',
    width: '480px'
  },
  formControl: {
    width: '100%'
  },
  waitingRoomVideoPreview: {
    margin: '1rem 0',
    '& > div': {
      border: '1px solid #909196',
      borderRadius: '8px',
      height: '360px !important',
      width: '480px !important'
    }
  },
  primaryButton: {
    background: '#03ACEF',
    border: 'none',
    borderRadius: '100px',
    color: '#FFFFFF',
    display: 'block',
    fontSize: '1rem',
    fontWeight: '700',
    height: '40px',
    lineHeight: '24px',
    margin: '1rem auto 0 auto',
      width: '100%',
    '&:active': {
      background: '#004F9A'
    },
    '&:hover': {
      background: '#004F9A',
      cursor: 'pointer'
    },
    '&:focus': {
      background: '#004F9A'
    },
  },
  memdTitleLarge: {
    fontWeight: 700,
    fontSize: '24px'
  },
  copy: {
    color: '#74767C',
    fontSize: '1rem',
    lineHeight: '24px'
  },
  inputGroup: {
    width: '100%'
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 700,
    marginTop: '1rem',
    padding: '8px 0 4px 4px',
    width: '100%'
  },
  input: {
    background: '#FFFFFF',
    border: '1px solid #909196',
    borderRadius: '4px',
    boxSizing: 'border-box',
    fontSize: '1rem',
    height: '56px',
    padding: '0 10px',
    width: '100%'
  },
  error: {
    color: '#DE1C24',
    fontSize: '14px',
    height: '20px',
    padding: '8px 0 4px 4px'
  }
}));
